export default __webpack_public_path__ + "static/media/deal.d7d9e1a6.svg";